import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-upload-file-mobile",
  templateUrl: "./upload-file-mobile.component.html",
  styleUrls: ["./upload-file-mobile.component.scss"],
})
export class UploadFileMobileComponent implements OnInit {
  constructor(public dialog: MatDialogRef<UploadFileMobileComponent>) {}

  ngOnInit(): void {}

  openCamera(){
    this.dialog.close(false);
  }

  openGalery(){
    this.dialog.close(true);
  }

  openGaleryOnKeyDown(event: KeyboardEvent) {
    this.openGalery();
  }

  openCameraOnKeyDown(event: KeyboardEvent) {
    this.openCamera();
  }
}
